export default __webpack_public_path__ + "static/media/Badminton Hall, PKL5.0f9477ab.jpg";